import EmailPassword from "supertokens-auth-react/recipe/emailpassword";
import Session from "supertokens-auth-react/recipe/session";
import Multitenancy from "supertokens-auth-react/recipe/multitenancy";

export function getApiDomain() {
    const apiPort = process.env.REACT_APP_API_PORT || 3001;
    const apiUrl = process.env.REACT_APP_API_URL || `http://localhost:${apiPort}`;
    return apiUrl;
}

export function getWebsiteDomain() {
    const websitePort = process.env.REACT_APP_WEBSITE_PORT || 3000;
    const websiteUrl = process.env.REACT_APP_WEBSITE_URL || `http://localhost:${websitePort}`;
    return websiteUrl;
}

export const styleOverride = `
[data-supertokens~=tenants-link] {
    margin-top: 8px;
}
`;

export const SuperTokensConfig = {
    appInfo: {
        appName: "Trievents",
        apiDomain: getApiDomain(),
        websiteDomain: getWebsiteDomain(),
    },
    usesDynamicLoginMethods: true,
    // recipeList contains all the modules that you want to
    // use from SuperTokens. See the full list here: https://supertokens.com/docs/guides
    style: styleOverride,
    recipeList: [
        EmailPassword.init(),
        Session.init({
            tokenTransferMethod: "header",
            override: {
                functions: (oI) => {
                    return {
                        ...oI,
                        getTokenTransferMethod: () => "header",
                    };
                },
            },
        }),
        Multitenancy.init({
            override: {
                functions: (oI) => {
                    return {
                        ...oI,
                        getTenantId: async () => {
                            const tenantIdInStorage = localStorage.getItem("tenantId");
                            return tenantIdInStorage === null ? undefined : tenantIdInStorage;
                        },
                    };
                },
            },
        }),
    ],
};


// Function to get tenant ID from storage
export const getTenantIdFromStorage = () => {
    return localStorage.getItem("tenantId");
};

// Function to set tenant ID in storage
export const setTenantIdInStorage = (tenantId: string) => {
    localStorage.setItem("tenantId", tenantId.toLowerCase());
};

// Function to remove tenant ID from storage
export const removeTenantIdFromStorage = () => {
    localStorage.removeItem("tenantId");
};

// Function to get the tenant ID for the current request
export const getTenantId = () => {
    return getTenantIdFromStorage();
};